import { render, staticRenderFns } from "./game-pc-bottom.vue?vue&type=template&id=820f5064&scoped=true"
import script from "./game-pc-bottom.vue?vue&type=script&lang=js"
export * from "./game-pc-bottom.vue?vue&type=script&lang=js"
import style0 from "./game-pc-bottom.vue?vue&type=style&index=0&id=820f5064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820f5064",
  null
  
)

export default component.exports